// ** MUI Imports
import { createGenericContext } from "../../utils/createGenericContext";
import { useAuth } from "../../auth";
import { useEffect, useState } from "react";
import FormsService from "../../services/FormsService";

export interface IAppContext {
  dashboardText: string;
  appName: [string, string];
  appNameLoaded: boolean;
  usage: string;
}

const [useAppContext, AppContextProvider] = createGenericContext<IAppContext>();

const AppProvider = (props: any) => {
  const [appName, setAppName] = useState<[string, string]>([
    "RedStar",
    "RedStar",
  ]);
  const [dashboardText, setDashboardText] = useState<string>("");
  const [usage, setUsage] = useState<string>("MENTALHEALTH");
  const [configLoaded, setConfigLoaded] = useState<boolean>(false);
  const [infoLoaded, setInfoLoaded] = useState<boolean>(false);

  const { isLoggedIn } = useAuth();

  useEffect(() => {
    FormsService.getConfig().then((res: any) => {
      setAppName([res.data.appName, res.data.appNameShort]);
      if (res.data.usage) setUsage(res.data.usage);
    }).finally(() => {
      // mark loaded even on failure so the fallback default can show
      setConfigLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      FormsService.getInfo().then((res: any) => {
        setAppName([res.data.service, res.data.short]);
        setDashboardText(res.data.dashboardText);
      }).finally(() => {
        setInfoLoaded(true);
      });
    }
  }, [isLoggedIn]);

  // For logged-in users the authoritative title comes from getInfo (the
  // service-specific name), so wait for that before showing the title to
  // avoid flashing the generic config name. Unauthenticated pages only have
  // getConfig, so show once that resolves.
  const appNameLoaded = isLoggedIn ? infoLoaded : configLoaded;

  let contextValue = {
    dashboardText,
    appName,
    appNameLoaded,
    usage,
  };

  return (
    <AppContextProvider value={contextValue}>
      {props.children}
    </AppContextProvider>
  );
};

export { AppProvider, useAppContext };
